import React from "react";
import style from "../../pages/news/HeaderNews/HeaderNews.module.css";
import { NavLink } from "react-router-dom";
import img from "../../assets/teachers.jpg";
import { useTranslation } from 'react-i18next';
const KamronHeader = () => {
  const { t } = useTranslation();
  return (
    <div>
      {/* <MobileNav1 /> */}
      <div className={style.HeaderNews}>
        <img src={img} alt="rasm bor edi!" />

        <div className={style.BlockLink}>
          <h1 >
            {t("my_teacher.name")}
          </h1>
          <NavLink
            to="/"
            className={style.Block1}
          >
            {t("homapage_r")}
          </NavLink>
          <a
            href="project/"
            className={style.Block2}
          >
            / {t("innerProject.project")}
          </a>
        </div>
      </div>
    </div>
  );
};
export default KamronHeader;
